// API клиент для управления приглашениями
import { apiClient } from './client'

// Типы
export interface InviteItem {
  id: string
  token: string
  email: string
  role: string
  org_id: string
  org_name: string | null
  creator_name: string | null
  expires_at: string
  used_at: string | null
  created_at: string
  is_expired: boolean
}

export interface InviteListResponse {
  items: InviteItem[]
  total: number
}

export interface InviteCreatePayload {
  email: string
  role: string
  org_id: string
  expires_in_hours?: number
}

export interface InviteValidateResponse {
  valid: boolean
  email: string | null
  org_name: string | null
  role: string | null
  expires_at: string | null
}

// API функции
export const fetchInvites = async (statusFilter?: string): Promise<InviteListResponse> => {
  const params = statusFilter ? { status_filter: statusFilter } : undefined
  const response = await apiClient.get<InviteListResponse>('/invites/', { params })
  return response.data
}

export const createInvite = async (data: InviteCreatePayload): Promise<InviteItem> => {
  const response = await apiClient.post<InviteItem>('/invites/', data)
  return response.data
}

export const revokeInvite = async (inviteId: string): Promise<void> => {
  await apiClient.delete(`/invites/${inviteId}`)
}

export const validateInvite = async (token: string): Promise<InviteValidateResponse> => {
  const response = await apiClient.get<InviteValidateResponse>(`/invites/validate/${token}`)
  return response.data
}
